import { ROLES } from "./system.constant";

export let routesPathConstants = {
  LOGIN: "/login",
  SHOPIFY_APP_INSTALL: "/ShopifyAppInstall",
  UNKNOWN_PATH: "/*",
  DEFAULT_PATH: "/",
  DASHBOARD: "/Dashboard",
  EMPLOYEES: "/Employees",
  FORGOT_PIN: "/ForgotPin",
  ADD_NEW_USER: "/Employees/Add",
  EMPLOYEE_LOGIN: "/EmployeeLogin",
  RESET_PASSWORD: "/ResetPassword",
  FORGOT_PASSWORD: "/ForgotPassword",
  ORDERS: "/Orders",

  //------ Sell/Trade
  SELL_AND_TRADE_ORDERS: "/SellAndTrade/Orders",
  SELL_AND_TRADE_DRAFTS: "/SellAndTrade/Drafts",
  SELL_AND_TRADE: "/SellAndTrade/NewTransaction",
  SELL_AND_TRADE_HISTORY: "/SellAndTrade/History",
  SELL_AND_TRADE_NEW_RETURN: "/SellAndTrade/NewReturn",
  INVENTORY_ITEMS_PRICE_CHANGES: "/Inventory/PriceChanges",
  SELL_AND_TRADE_NEW_TRANSACTION: "/SellAndTrade/NewTransaction",
  SELL_AND_TRADE_CASH_MANAGEMENT: "/SellAndTrade/CashManagement",
  SELL_AND_TRADE_NEW_TRADE: "/SellAndTrade/NewTransaction/NewTrade",
  SELL_AND_TRADE_REGISTER_SESSIONS: "/SellAndTrade/RegisterSessions",
  SELL_AND_TRADE_SESSION_DETAIL: "/SellAndTrade/RegisterSessions/SessionDetail",
  SELL_AND_TRADE_OPEN_CLOSE_REGISTER: "/SellAndTrade/OpenCloseRegister",
  SELL_AND_TRADE_NEW_TRANSACTION_PAYMENT:
    "/SellAndTrade/NewTransaction/Payment",
  SELL_AND_TRADE_NEW_TRADE_PAYMENT:
    "/SellAndTrade/NewTransaction/NewTrade/Payment",

  //------- Settings
  SETTINGS: "/Settings/Users",
  SETTINGS_USERS: "/Employees",
  SETTINGS_DEVICES: "/Settings/Devices",
  SETTINGS_OUTLETS: "/Settings/Outlets",
  SETTINGS_DISCOUNT: "/Settings/Discount",
  SETTINGS_TRADE_INS: "/Settings/TradeIns",
  SETTINGS_EMPLOYEES: "/Settings/Employees",
  SETTINGS_USERS_EDIT_USER: "/Employees/Edit",
  SETTINGS_DEVICES_ADD: "/Settings/Devices/Add",
  SETTINGS_DEVICES_EDIT: "/Settings/Devices/Edit",
  SETTINGS_PRICE_CHANGES: "/Settings/PriceChanges",
  SETTINGS_PRESET_PRICES: "/Settings/PriceMarkups",
  SETTINGS_DISCOUNT_CREATE: "/Settings/Discount/Create",
  SETTINGS_RECEIPT_AND_LABELS: "/Settings/StoreSettings",
  SETTINGS_ITEM_ORGANIZATION: "/Settings/ItemOrganization",
  SETTINGS_PRINTER_SETTINGS: "/Settings/Printer-Settings",
  SETTINGS_SHOPIFY_CONNECTION: "/Settings/ShopifyConnection",
  SETTINGS_SHOPIFY_PRESETS: "/Settings/ShopifyPresets",

  // Misc routes
  BILLING: "/Billing",
  PAYOUTS: "/Payouts",
  REPORT_ISSUE: "/ReportIssue",
  PRINTER_SETTINGS: "/PrinterSetting",
  USER_INFORMATION: "/UserInformation",

  // Admin tab routes
  ADMIN: "/Admin/Stores",
  ADMIN_STORES: "/Admin/Stores",
  ADMIN_DEVICES: "/Admin/Devices",
  ADMIN_COMPANIES: "/Admin/Companies",
  ADMIN_STORES_ADD: "/Admin/Stores/Add",
  ADMIN_SYSTEMUSERS: "/Admin/Superadmins",
  ADMIN_STORES_EDIT: "/Admin/Stores/Edit",
  ADMIN_DEVICES_ADD: "/Admin/Devices/Add",
  ADMIN_DEVICES_EDIT: "/Admin/Devices/Edit",
  ADMIN_COMPANIES_ADD: "/Admin/Companies/Add",
  ADMIN_COMPANIES_EDIT: "/Admin/Companies/Edit",
  ADMIN_SYSTEMUSERS_ADD: "/Admin/Superadmins/Add",
  ADMIN_SYSTEMUSERS_EDIT: "/Admin/Superadmins/Edit",

  //Customer
  CUSTOMERS: "/Customers",
  CUSTOMERS_ADD: "/Customers/Add",
  CUSTOMERS_EDIT: "/Customers/Edit",

  //------ Analytices
  ANALYTICS_SALES_SUMMARY: "/Analytics/SalesSummary",

  //------- Invnetory
  INVENTORY: "/Inventory/Items",
  INVENTORY_ITEMS: "/Inventory/Items",
  INVENTORY_EDIT: "/Inventory/Items/Edit",
  INVENTORY_INVOICES: "/Inventory/Invoices",
  INVENTORY_ITEMS_HISTORY: "/Inventory/History",
  INVENTORY_ITEMS_SUMMARY: "/Inventory/Summary",
  CHANGE_PRICE: "/Inventory/PriceChanges/ChangePrice",
  INVENTORY_ITEMS_STOCK_AUDIT: "/Inventory/StockAudit",
  INVENTORY_ITEMS_STOCK_AUDIT_SESSION: "/Inventory/StockAudit/Session",
  INVENTORY_ITEMS_STOCK_AUDIT_CATEGORY: "/Inventory/StockAudit/Category",
  INVENTORY_ITEMS_STOCK_AUDIT_BREAKDOWN: "/Inventory/StockAudit/Breakdown",
};

export const routesPathConstantsSetter = (updatedRoutesArray) => {
  updatedRoutesArray.forEach((routeObject) => {
    routesPathConstants[`${routeObject.key}`] = routeObject.value;
  });
};

export const STORE_OWNER_NOT_ALLOWED_ROUTES = Object.values(
  routesPathConstants
).filter((route) => route.toLowerCase().includes(ROLES.ADMIN.toLowerCase()));

export const STORE_MANAGER_NOT_ALLOWED_ROUTES = [
  routesPathConstants.BILLING,
  routesPathConstants.PAYOUTS,
];

export const EMPLOYEE_NOT_ALLOWED_ROUTES = [
  routesPathConstants.DASHBOARD,
  routesPathConstants.BILLING,
  routesPathConstants.PAYOUTS,
  routesPathConstants.SETTINGS_USERS,
  routesPathConstants.SETTINGS_USERS_EDIT_USER,
  routesPathConstants.ADD_NEW_USER,
  routesPathConstants.SETTINGS_DEVICES,
  routesPathConstants.SETTINGS_DEVICES_ADD,
  routesPathConstants.SETTINGS_DEVICES_EDIT,
  routesPathConstants.SETTINGS_DISCOUNT,
  routesPathConstants.SETTINGS_DISCOUNT_CREATE,
  routesPathConstants.SETTINGS_TRADE_INS,
  routesPathConstants.SETTINGS_ITEM_ORGANIZATION,
  routesPathConstants.SETTINGS_PRESET_PRICES,
  routesPathConstants.SETTINGS_RECEIPT_AND_LABELS,
  routesPathConstants.ANALYTICS_SALES_SUMMARY,
  routesPathConstants.SETTINGS_OUTLETS,
  routesPathConstants.SELL_AND_TRADE_SESSION_DETAIL,
  routesPathConstants.SELL_AND_TRADE_REGISTER_SESSIONS,
];

export const STORE_INACTIVE_ROUTES = [
  routesPathConstants.BILLING,
  routesPathConstants.PAYOUTS,
  routesPathConstants.USER_INFORMATION,
  routesPathConstants.DASHBOARD,
  routesPathConstants.UNKNOWN_PATH,
  routesPathConstants.DEFAULT_PATH,
];

export const OUTLET_DISABLED_ROUTES = [
  routesPathConstants.SETTINGS_OUTLETS,
  routesPathConstants.SELL_AND_TRADE_SESSION_DETAIL,
  routesPathConstants.SELL_AND_TRADE_CASH_MANAGEMENT,
  routesPathConstants.SELL_AND_TRADE_REGISTER_SESSIONS,
  routesPathConstants.SELL_AND_TRADE_OPEN_CLOSE_REGISTER,
];

export const NESTED_SIDEBAR_SETTING_OUTLET = [
  routesPathConstants.SETTINGS_OUTLETS,
];

export const NESTED_SIDEBAR_SELL_TRADE_OUTLET_ROUTES = [
  routesPathConstants.SELL_AND_TRADE_SESSION_DETAIL,
  routesPathConstants.SELL_AND_TRADE_CASH_MANAGEMENT,
  routesPathConstants.SELL_AND_TRADE_REGISTER_SESSIONS,
  routesPathConstants.SELL_AND_TRADE_OPEN_CLOSE_REGISTER,
];

export const NESTED_SIDEBAR_SETTING_SHOPIFY = [
  routesPathConstants.SETTINGS_SHOPIFY_PRESETS,
  routesPathConstants.SELL_AND_TRADE_ORDERS,
];

export const NESTED_SIDEBAR_SETTING_SHOPIFY_IS_INTEGRATION_ENABLED = [
  routesPathConstants.SETTINGS_SHOPIFY_CONNECTION,
  routesPathConstants.SETTINGS_SHOPIFY_PRESETS,
  routesPathConstants.SELL_AND_TRADE_ORDERS,
];

export const NON_INVENTORY_ROUTES = [
  routesPathConstants.SETTINGS_TRADE_INS,
  routesPathConstants.SETTINGS_DISCOUNT,
  routesPathConstants.SETTINGS_PRESET_PRICES,
  routesPathConstants.SETTINGS_RECEIPT_AND_LABELS,
  routesPathConstants.SETTINGS_OUTLETS,
  routesPathConstants.PAYOUTS,
  routesPathConstants.DASHBOARD,
  routesPathConstants.ANALYTICS_SALES_SUMMARY,

  routesPathConstants.SELL_AND_TRADE_ORDERS,
  routesPathConstants.SELL_AND_TRADE_DRAFTS,
  routesPathConstants.SELL_AND_TRADE,
  routesPathConstants.SELL_AND_TRADE_HISTORY,
  routesPathConstants.SELL_AND_TRADE_NEW_RETURN,
  routesPathConstants.INVENTORY_ITEMS_PRICE_CHANGES,
  routesPathConstants.SELL_AND_TRADE_NEW_TRANSACTION,
  routesPathConstants.SELL_AND_TRADE_CASH_MANAGEMENT,
  routesPathConstants.SELL_AND_TRADE_NEW_TRADE,
  routesPathConstants.SELL_AND_TRADE_REGISTER_SESSIONS,
  routesPathConstants.SELL_AND_TRADE_SESSION_DETAIL,
  routesPathConstants.SELL_AND_TRADE_OPEN_CLOSE_REGISTER,
  routesPathConstants.SELL_AND_TRADE_NEW_TRANSACTION_PAYMENT,
  routesPathConstants.SELL_AND_TRADE_NEW_TRADE_PAYMENT,
];
